import './sw-cms-el-acris-blog-title.scss';

const { Mixin } = Shopware;

/**
 * @private
 * @sw-package discovery
 */
export default {
    mixins: [
        Mixin.getByName('cms-element'),
    ],

    computed: {
        isBlogPage() {
            return this.cmsPageState?.currentPage?.type ?? '' === 'cms_blog';
        },
    },

    methods: {
        createdComponent() {
            this.initElementConfig('acris-blog-title');

            if (this.isBlogPage && !this.element?.translated?.config?.content) {
                this.element.config.content.source = 'mapped';
                this.element.config.content.value = 'acris_blog.title';
            }
            this.updateDemoValue();
        },

        updateDemoValue() {
            if (this.element.config.content.source === 'mapped') {
                let label = '';
                let className = 'sw-cms-el-acris-blog-title__skeleton';

                if (this.element.config.content.value === 'acris_blog.title') {
                    className = 'sw-cms-el-acris-blog-title__placeholder';
                    label = this.$tc('acris-blog.elements.blogTitle.preview.title');
                }

                this.demoValue = `<h1 class="${className}">${label}</h1>`;

                if (this.cmsPageState.currentDemoEntity) {
                    this.demoValue = this.getDemoValue(this.element.config.content.value);
                }
            }
        },
    },
};
